import { message, Upload } from "antd"
import { Loading } from "react-daisyui"
import { ReactComponent as PLUS } from "../../assets/PlusICON.svg"

/** Rückmeldung an das Upload-Feld: beendet Ladezustand und den Upload in antd. */
export type TImageUploadDone = {
    onSuccess: () => void
    onError: (error: unknown) => void
}

type BaseImageUploadType = {
    // done z. B. als Optionen an mutate(...) durchreichen
    onUpload: (formData: FormData, done: TImageUploadDone) => void
    data: string
    loading: boolean
    setLoading: (loading: boolean) => void
    classProps?: string
}

export default function BaseImageUpload(props: BaseImageUploadType) {
    const beforeUpload = (file: File) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png"
        if (!isJpgOrPng) {
            message.error("Es sind nur JPG- und PNG-Dateien erlaubt.")
            return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
            message.error("Das Bild muss kleiner als 2 MB sein.")
            return false
        }
        return true
    }

    // Upload the new image (über authenticatedAxiosInstance im onUpload-Callback, Session-Cookie)
    const customUpload = async (options: any) => {
        const { file } = options
        props.setLoading(true)
        const formData = new FormData()
        formData.append("image", file)
        props.onUpload(formData, {
            onSuccess: () => {
                props.setLoading(false)
                options.onSuccess?.({})
            },
            onError: (error) => {
                // z. B. 400 "Die Datei ist zu groß." – die Meldung zeigt die Mutation
                props.setLoading(false)
                options.onError?.(error)
            },
        })
    }

    return (
        <div className="flex justify-center w-full">
            <Upload
                name="image"
                className={`w-96 h-32 items-center justify-center flex rounded-default border-black border-2 mb-2 overflow-hidden ${props.classProps}`}
                showUploadList={false}
                beforeUpload={beforeUpload}
                customRequest={customUpload}>
                {props.data ? (
                    <img src={props.data ?? ""} alt="avatar" className="max-w-full max-h-full object-cover object-center" />
                ) : (
                    <button style={{ border: 0, background: "none" }} className="flex flex-col justify-center items-center" type="button">
                        {props.loading ? <Loading /> : <PLUS className="w-6 h-6" />}
                        <p>Bild des Objekts</p>
                    </button>
                )}
            </Upload>
        </div>
    )
}
